import { useTranslation } from 'react-i18next';

import { modalState } from '@/state/modal.state';

import { useRevokeInvitation } from '../settings/invited-users/use-revoke-invitation.mutation';

import { ConfirmDeleteModal } from './confirm-delete-modal';
import { useAtomValue } from 'jotai';

export const RevokeInvitationModal = () => {
  const modal = useAtomValue(modalState);
  const { t } = useTranslation('settings');
  const { revokeInvitation, isLoading } = useRevokeInvitation();

  if (!modal || modal.state !== 'revokeInvitation') return null;

  return (
    <ConfirmDeleteModal
      description={t`revokeDescription`}
      onConfirm={() => revokeInvitation(modal.userId)}
      confirmLabel={t`Revoke`}
      isLoading={isLoading}
    />
  );
};
